import { Link } from "react-router-dom";

export const Footer = ({ t }) => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#08080a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <img src="/logo-full.png" alt="Vollmermontagen GmbH" className="h-16 w-auto" />
            <p className="text-sm text-neutral-500 max-w-xs">{t.footer.tagline}</p>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/impressum" data-testid="footer-legal-link" className="font-mono-accent text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-pink-brand transition-colors duration-200">
              {t.footer.legal}
            </Link>
            <Link to="/datenschutz" data-testid="footer-privacy-link" className="font-mono-accent text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-pink-brand transition-colors duration-200">
              {t.footer.privacy}
            </Link>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2">
          <p className="font-mono-accent text-xs text-neutral-600">© 2026 Vollmermontagen GmbH · Ottikon</p>
          <p className="font-mono-accent text-xs text-neutral-600">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
